<template>
	<menu-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
		<template v-slot:activator = '{on}'>
			<v-btn v-on = 'on' :disabled = 'user.grant_name == "default"' slot = 'activator' color = 'light-blue lighten-2' icon small @click.stop.prevent = 'visibility = !visibility' class = 'px-0 mx-0'>
				<v-icon small>mdi-square-edit-outline</v-icon>
			</v-btn>
		</template>
        <template v-slot:title>{{user.name}} {{user.lastname}}</template>
        <template v-slot:content>
			<v-form class = 'mx-4'>
				<v-select
					v-model = 'user.mode_edit'
					:items = "modeReport"
					item-text = "text"
					item-value = "value"
					label = "Содержимое отчета"
					hint = 'Доступ к отчету'
					persistent-hint
					single-line
					:rules = "[rules.required]"
				></v-select>
				<v-select
					v-model = 'user.mode_persons'
					:items = "modePersons"
					item-text = "text"
					item-value = "value"
					label = "Пользователи отчета"
					hint = 'Доступ к пользователям отчета'
					persistent-hint
					single-line
					:rules = "[rules.required]"
				></v-select>
				<v-text-field
					v-model = 'user.mode_name'
					label = 'Отображаемое название роли'
					counter = '40'
					:rules = '[rules.length, rules.required]'
				></v-text-field>
				<v-text-field
					v-model = 'user.mode_description'
					label='Отображаемое описание роли'
				></v-text-field>
				<v-checkbox 
					v-model = 'set_expiration'
					class = 'my-0 py-0 mb-4'
					hide-details
				>
					<template v-slot:label>
						<span class = 'ml-1'>Назначить <b>срок действия</b> доступов</span>
					</template>
				</v-checkbox>
				<v-menu 
					v-if = 'set_expiration'
                    ref = "selectedDate" 
                    :close-on-content-click = "false" 
                    :return-value.sync = "user.expire_on" 
                    offset-y 
                    v-model = 'selectedDate'
                >
                    <template v-slot:activator = '{ on }'>
                        <v-text-field 
                            v-on = 'on' 
                            v-model = 'user.expire_on' 
                            clearable 
                            label = 'Окончание срока действия'
                        ></v-text-field>
                    </template>
                    <v-date-picker 
                        :rules = "[rules.required]" 
                        style = 'width: 100%;' 
                        :header-color = '$store.getters.uiAccent' 
                        v-model = 'user.expire_on' 
                        @input = "$refs.selectedDate.save(user.expire_on)" 
                        locale = 'ru-ru' 
                        :min = 'min_expiration'
                        first-day-of-week='1'
                    ></v-date-picker>
                </v-menu>
			</v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :loading = 'indicator' block depressed @click = 'updateReportPerson'>Изменить</v-btn>
        </template>
    </menu-generic>
</template>

<script>
	import MenuGeneric from '@/components/elements/menus/Generic.vue'
	import dayjs from 'dayjs'

	export default {
		name: 'UserReportUpdateMenu',
		props: ['data', 'postAction', 'report'],
		components: {MenuGeneric},
		data() {
			return {
		        modeReport: [
		        	{'text':'Просмотр отчета','value':'R'},
		          	{'text':'Изменение и обновление отчета','value':'W'}
		        ],
		        modePersons: [
		        	{'text':'Нет доступа к списку пользователей','value':'R'},
		          	{'text':'Просмотр списка пользователей','value':'W'},
		          	{'text':'Управление списком пользователей','value':'X'}
		        ],
				visibility: false,
				user: this.data,
				indicator: false,
				set_expiration: this.data.expire_on !== null,
				selectedDate: false,
				min_expiration: dayjs().add(1, 'day').format('YYYY-MM-DD'),
				rules: {
					required: value => !!value || 'Обязательное поле.',
					length: value => value.length <= 40 || 'Не длинее 40 символов'
				}
			}
		},
		watch: {
			visibility (value) {
				if (value && this.user.expire_on) {
					this.user.expire_on = dayjs(this.user.expire_on).format('YYYY-MM-DD')
				}
			},
	        data(value) {
				this.user = value
			},
			set_expiration (value) {
				if (!value) {
					this.user.expire_on = null
				}
			}
	    },
		methods: {
			updateReportPerson() {
				this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + this.$store.getters.userToken
		        }
			    this.$http.put(this.$store.getters.endpoint + '/db/reports/persons', {
			        ...{'login': this.$store.getters.userLogin, 'report_id': this.report.report_id},...this.user
			        },{
			            headers: {...this.$store.state.restrictedHeaders,...requestHeaders
			        }
			    }).then( (r) => {
					let response = r.body;
					this.indicator = false;
			        if (response.result) {
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'update',
                                target: 'report_user'
                            },
                            once: false
                        })
			            this.postAction();
			            this.visibility = false;
			        } else {
			            console.log(response)
			        }
			    }).catch( (e) => {
					this.indicator = false;
				})
			}
		}
	}
</script>